/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import AccountCustomerBalanceTile from './account-customer-balance-tile';
import AccountCustomerBalanceTileView from './account-customer-balance-tile.view';

export * from './account-customer-balance-tile';
export * from './account-customer-balance-tile.data';
export {
    IAccountCustomerBalanceTileConfig,
    IAccountCustomerBalanceTileProps,
    IAccountCustomerBalanceTileResources
} from './account-customer-balance-tile.props.autogenerated';
export * from './account-customer-balance-tile.view';
export * from './components';

export { AccountCustomerBalanceTile, AccountCustomerBalanceTileView };
